export default {"src":"/evde-internet/_next/static/media/acceleration.a7df630d.svg","height":48,"width":48};